import { DataSyncStatus, SYNC_FAILED } from '../../../types/dataSync'

/**
 * How old the data may get before the banner warns about it.
 *
 * A constant, not a setting: 24 or 48 hours would fire every Monday if the
 * customer does not deliver over the weekend, and the alert is only worth
 * anything if it means something is actually wrong.
 */
export const STALE_AFTER_HOURS = 72

export type BannerVariant = 'ok' | 'stale' | 'failed' | 'never'

export const resolveBannerVariant = (
  sync: DataSyncStatus,
  now: Date = new Date()
): BannerVariant => {
  if (sync.status === SYNC_FAILED) return 'failed'
  if (!sync.dataReceivedAt) return 'never'

  const dataReceivedAt = new Date(sync.dataReceivedAt)
  // A malformed timestamp must not fall through to the healthy branch: NaN
  // comparisons are always false, so an unparseable date would otherwise
  // silently resolve to 'ok'. There is no usable received-at time, which is
  // exactly what 'never' already means.
  if (Number.isNaN(dataReceivedAt.getTime())) return 'never'

  const ageHours = (now.getTime() - dataReceivedAt.getTime()) / 3_600_000

  return ageHours > STALE_AFTER_HOURS ? 'stale' : 'ok'
}
